import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';
import { store } from 'src/common/redux/configure-store';
import { CartResponse } from './interfaces/cart-response';
import { LineItemAddDto } from './interfaces/line-item-add.dto';

export const addItem = async (lineItemAddRequest: LineItemAddDto): Promise<CartResponse> => {
  const transactionId: string = store.getState().transaction.transactionId;
  const axiosConfig: AxiosRequestConfig = {
    url: `/transaction-management/transactions/${transactionId}/items/add`,
    method: 'POST',
    data: lineItemAddRequest,
  };
  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoggingInfo: true,
    spanOptions: { name: 'add-item' },
  };

  const response = await emeraldRequest<AddItemResponse>(emeraldRequestParams);
  return response.transaction;
};

export interface AddItemResponse {
  transaction: CartResponse;
}
